import { City } from '../../types/City';

export const mappedCities = (cities: City[]): City[] => {
  return cities
    .map((city, index) => ({
      ...city,
      order: city.order || (index + 1) * 1000,
      picture: {
        isNew: false,
        blob: null,
        data: (city.picture as unknown) as string,
      },
      exploreConfigurations: city.exploreConfigurations || [],
    }))
    .sort((a, b) => (a.order && b.order ? a.order - b.order : 0))
    .filter(city => city.name !== '#default');
};
